import React, { useEffect, useState } from 'react';
import '../../Assets/css/counter.css'; // Make sure to create this CSS file

const Counter = ({ end }) => {
    const [count, setCount] = useState(0);

    useEffect(() => {
        let start = 0;
        const duration = 2000; // duration of the animation in milliseconds
        const increment = end / (duration / 50);

        const counter = setInterval(() => {
            start += increment;
            if (start >= end) {
                clearInterval(counter);
                start = end;
            }
            setCount(Math.floor(start));
        }, 50);

        return () => clearInterval(counter);
    }, [end]);

    return <div className="counter">{count}</div>;
};

export default Counter;
